export const omitProfiles = [
  42, 46, 12, 48, 1, 13, 15, 55, 11, 35, 72, 70, 17, 38, 7, 71, 75, 9, 43, 10,
  6, 56, 33, 39, 18, 14, 34, 45, 44, 19, 73, 74,
];

export const omitDepartments = [
  16, 42, 52, 66, 67, 68, 169, 172, 176, 186, 187, 188, 189, 190, 191, 215, 217,
  241, 242, 243, 238, 239, 240, 227, 226, 230, 247, 245, 290, 278, 279, 267,
  268, 269, 270, 271, 272, 273, 274, 275, 276, 278, 279, 280, 281, 282, 283,
  284, 285, 286, 277, 298,
];
